import {
  isEqual,
  pick,
  uniqWith,
  get,
  set,
  groupBy,
  has
} from '../../core/object-utils';

/**
 * Method that set errors on a processInstance after the case was submitted
 * @param errorList
 * @param processInstance
 */
const setErrors = (
  errorList: AmplifyAPI.AmplifyError[],
  processInstance: AmplifyAPI.ProcessInstance
): AmplifyAPI.ProcessInstance => {
  // synthetically create issues for vitalware
  processInstance.errorMessages = [];

  const groupedErrorlist = groupBy(errorList, 'field');

  Object.keys(groupedErrorlist).forEach(errorField => {
    // change the last element for errorMessages key
    const fieldObject = groupedErrorlist[errorField][0] ?? { field: '' };
    let pathChange = fieldObject?.field?.split('.');
    if (pathChange?.length >= 1) {
      pathChange[pathChange?.length - 1] = 'errorMessages';

      const existingErrorMessages = get(
        processInstance,
        pathChange.join('.'),
        []
      );
      const combinedErrorMessages = [
        ...existingErrorMessages,
        ...groupedErrorlist[errorField]
      ];

      //Need to pick the selected props from error object due version inclusion and extra info addition to error dto
      const partialCombinedErrorMessages = combinedErrorMessages.map(error =>
        pick(error, ['field', 'message_key', 'message', 'source'])
      );

      // set the list of error to the required level when path exists
      //if global errors set errors else set errors when path exists
      if (
        has(processInstance, pathChange.slice(0, -1).join('.')) ||
        pathChange.slice(0, -1).length === 0
      ) {
        set(
          processInstance,
          pathChange.join('.'),
          uniqWith(partialCombinedErrorMessages, isEqual)
        );
      }
    }
  });

  return processInstance;
};

export { setErrors };
